import { render } from "./TypeIndustries.vue?vue&type=template&id=425b795c"
import script from "./TypeIndustries.vue?vue&type=script&lang=js"
export * from "./TypeIndustries.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__